export default __webpack_public_path__ + "static/round-button-3b6e0195f44e41bbb1e46353e4bb8186.png";